export default function HowToVerifySection() {
  return (
    <section id="verify" className="py-16 md:py-20 bg-[#F7F8FA]">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4 text-center">
          How to Verify Any Passport Expediting Service Before You Use Them
        </h2>
        <p className="text-gray-600 text-center max-w-2xl mx-auto mb-12 text-base md:text-lg">
          Three simple checks that separate legitimate registered expediters from marketing-only operations.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          <div className="bg-white rounded-lg p-8 border border-[#D0D7E2] relative">
            <div className="w-10 h-10 rounded-full bg-[#1A365D] flex items-center justify-center text-white font-bold text-lg mb-5">
              1
            </div>
            <h3 className="font-bold text-[#1A365D] text-lg mb-3">Check the State Dept. Registry</h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              Go to travel.state.gov and find the registered courier list. If they're not on it, they cannot legally submit applications directly to passport agencies. Fast Passport Center has been on this list for <strong className="text-[#1A365D]">20+ years</strong>.
            </p>
          </div>

          <div className="bg-white rounded-lg p-8 border border-[#D0D7E2] relative">
            <div className="w-10 h-10 rounded-full bg-[#1A365D] flex items-center justify-center text-white font-bold text-lg mb-5">
              2
            </div>
            <h3 className="font-bold text-[#1A365D] text-lg mb-3">Check Their BBB Rating</h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              Fast Passport Center holds an <strong className="text-[#1A365D]">A+ BBB rating</strong>. Any legitimate expediter should have a verifiable BBB record with clean complaint history. Check before you pay.
            </p>
          </div>

          <div className="bg-white rounded-lg p-8 border border-[#D0D7E2] relative">
            <div className="w-10 h-10 rounded-full bg-[#1A365D] flex items-center justify-center text-white font-bold text-lg mb-5">
              3
            </div>
            <h3 className="font-bold text-[#1A365D] text-lg mb-3">Verify a Real Physical Presence</h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              Legitimate expediters have real offices and drop-off locations. Fast Passport Center has <strong className="text-[#1A365D]">24 physical drop-off locations nationwide</strong>. Be cautious of services with only a website and no verifiable address.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}